// Copyright (c) 2016 Deere & Company

export const bindOnConfirmActions = (action, claim, actions) => ({
    addRep: actions.addRep.bind(null, claim),
    adjust: actions.adjust.bind(null, action),
    copy: actions.copy.bind(null, claim),
    delete: actions.delete.bind(null, action),
    pushxml: actions.pushxml.bind(null, action),
    reconcile: actions.reconcile.bind(null, action),
    unreconcile: actions.unreconcile.bind(null, action),
    unsubmit: actions.unsubmit.bind(null, action)
});

export const confirmationModalMap = (action, onClose, confirmActions) => ({
    ADD_REP: {
        confirmMessage: 'CONFIRM_ADDITIONAL_REPAIR',
        isOpen: true,
        onClose,
        onConfirm: () => {

            confirmActions.addRep();
            onClose();

        },
        title: 'ADDITIONAL_REPAIR'
    },
    COPY_CLAIM: {
        confirmMessage: 'CONFIRM_COPY_CLAIM',
        isOpen: true,
        onClose,
        onConfirm: () => {

            confirmActions.copy();
            onClose();

        },
        title: 'COPY_CLAIM'
    },
    DEL: {
        confirmMessage: 'CONFIRM_DELETE_CLAIM',
        isOpen: true,
        onClose,
        onConfirm: () => {

            confirmActions.delete();
            onClose();

        },
        title: 'DELETE_CLAIM'
    },
    PUSH_XML: {
        confirmMessage: 'CONFIRM_RESEND_XML',
        isOpen: true,
        onClose,
        onConfirm: () => {

            confirmActions.pushxml();
            onClose();

        },
        title: 'RESEND_XML'
    },
    RECONCILE: {
        confirmMessage: 'CONFIRM_RECONCILE_CLAIM',
        isOpen: true,
        onClose,
        onConfirm: () => {

            confirmActions.reconcile();
            onClose();

        },
        title: 'RECONCILE_CLAIM'
    },
    REQ_ADDL: {
        confirmMessage: 'CONFIRM_ADJUST_CLAIM',
        isOpen: true,
        onClose,
        onConfirm: () => {

            confirmActions.adjust();
            onClose();

        },
        title: 'ADJUST_CLAIM'
    },
    UNRECONCIL: {
        confirmMessage: 'CONFIRM_UNRECONCILE_CLAIM',
        isOpen: true,
        onClose,
        onConfirm: () => {

            confirmActions.unreconcile();
            onClose();

        },
        title: 'UNRECONCILE_CLAIM'
    },
    UNSUB: {
        confirmMessage: 'CONFIRM_EDIT_CLAIM',
        isOpen: true,
        onClose,
        onConfirm: () => {

            confirmActions.unsubmit();
            onClose();

        },
        title: 'UNSUBMIT_CLAIM'
    }
}[action.id]);



// WEBPACK FOOTER //
// ./src/claim/normal/services/confirmation-modal-map.js